if (typeof Object.create !== 'function') {
    Object.create = function (obj) {
        function F() {
        };
        F.prototype = obj;
        return new F();
    };
}

(function ($, window, document, undefined) {
    var GsmConfirmation = {
        init: function (options, elem) {
            var self = this;

            self.elem = elem;
            self.$elem = $(elem);

            $('body').append(self.modal);
            self.$modal = $('#gsmConfirmModal');

            self.$form = $('#gsmConfirmForm');

            self.$form.find('.errors').html('');

            self.$message = $('#gsmConfirmMessage');

            var dataKeys = Object.keys(self.$elem.data());

            for (var i = 0; i < dataKeys.length; i++) {
                options[dataKeys[i]] = self.$elem.data(dataKeys[i]);
            }

            self.options = $.extend({}, $.fn.gsmConfirmation.options, options);

            if (!self.options.checkingUrl) {
                self.options.checkingUrl = self.elem.action;
            }

            if (!self.options.mustConfirmGsm || !self.$elem.find(self.options.mustConfirmGsm)) {
                return;
            }

            function checkConfirmStatus(e) {
                e.preventDefault();

                self.options.beforeSubmit();

                var input = self.$elem.find(self.options.mustConfirmGsm);

                self.loadingButton(self.$elem.find('button[type=submit]'), true);

                self.options.phone = input.val();

                var data = {
                    'phone': self.options.phone,
                    '_token': self.options['_token'],
                    'code': self.$form.find('[name=code]').val()
                };

                if (self.options.additionalInputName){
                    data[self.options.additionalInputName] = $('[name=' + self.options.additionalInputName + ']:checked').val()
                }

                $.ajax({
                    type: "POST",
                    url: self.options.checkingUrl,
                    data: data,
                    dataType: 'json',
                    success: function (response) {

                        self.$elem.off('submit', checkConfirmStatus);

                        self.$elem.submit();

                    },
                    error: function (error) {

                        if (error.status === 401) {

                            $('#gsmConfirmModal').modal('show');

                            self.sendCode();

                            self.loadingButton(self.$elem.find('button[type=submit]'), false);

                        } else {

                            self.$elem.off('submit', checkConfirmStatus);

                            self.$elem.submit();

                        }

                    },
                    complete: function () {

                    }
                });
            }

            function confirm(e) {

                e.preventDefault();

                self.loadingButton(self.$form.find('button[type=submit]'), true);

                self.$form.find('.errors').html('');

                $.ajax({
                    type: "POST",
                    url: self.options.confirmCodeUrl,
                    data: {
                        'phone': self.options.phone,
                        '_token': self.options['_token'],
                        'code': self.$form.find('[name=code]').val()
                    },
                    dataType: 'json',
                    success: function () {

                        $('#gsmConfirmModal').modal('hide');

                        self.$elem.off('submit', checkConfirmStatus);

                        self.$elem.submit();

                    },
                    error: function (error) {

                        if ((error.status === 422 || error.status === 403) && error.responseJSON.errors) {

                            var $list = $('<ul class="mb-0 mt-4"></ul>');

                            $.each(error.responseJSON.errors, function (key, errors) {

                                $.each(errors, function (key2, error_message) {

                                    $list.append('<li class="text-danger"><small>' + error_message + '</small></li>');

                                });

                            });

                            self.$form.find('.errors').html($list);

                        }

                        self.loadingButton(self.$form.find('button[type=submit]'), false);

                    },
                    complete: function () {

                    }
                })

            }

            self.$elem.on('submit', checkConfirmStatus);

            self.$modal.find('form').on('submit', confirm);

            self.initVerificationInputs();

        },

        initVerificationInputs: function() {
            var self = this;
            var digits = self.$modal.find('.verification-digit');
            var hiddenInput = self.$modal.find('#gsmConfirmationCodeHidden');
            var submitButton = self.$modal.find('button[type=submit]');

            function updateHiddenInput() {
                var code = '';
                digits.each(function() {
                    code += $(this).val();
                });
                hiddenInput.val(code);

                // Enable submit button only if all digits are filled
                if (code.length === 6) {
                    submitButton.prop('disabled', false);
                } else {
                    submitButton.prop('disabled', true);
                }
            }

            digits.on('input', function(e) {
                var $this = $(this);
                var value = $this.val();
                var index = parseInt($this.data('index'));

                // Only allow numbers
                value = value.replace(/[^0-9]/g, '');
                $this.val(value);

                // Auto focus next input
                if (value && index < 5) {
                    digits.eq(index + 1).focus();
                }

                updateHiddenInput();
            });

            digits.on('keydown', function(e) {
                var $this = $(this);
                var index = parseInt($this.data('index'));

                // Handle backspace
                if (e.key === 'Backspace' && !$this.val() && index > 0) {
                    digits.eq(index - 1).focus();
                }
            });

            // Handle paste event properly
            digits.on('paste', function(e) {
                e.preventDefault();

                var paste = (e.originalEvent.clipboardData || window.clipboardData).getData('text');
                var numbers = paste.replace(/[^0-9]/g, '').substring(0, 6);

                if (numbers.length > 0) {
                    // Clear all inputs first
                    digits.val('');

                    // Fill inputs with pasted numbers
                    for (var i = 0; i < numbers.length && i < 6; i++) {
                        digits.eq(i).val(numbers.charAt(i));
                    }

                    // Focus the next empty input or the last filled input
                    if (numbers.length < 6) {
                        digits.eq(numbers.length).focus();
                    } else {
                        digits.eq(5).focus();
                    }

                    updateHiddenInput();
                }
            });

            // Handle focus and select all text
            digits.on('focus', function() {
                $(this).select();
            });

            // Auto focus first input when modal opens
            self.$modal.on('shown.bs.modal', function() {
                digits.eq(0).focus();
            });

            // Clear all inputs when modal is hidden
            self.$modal.on('hidden.bs.modal', function() {
                digits.val('');
                hiddenInput.val('');
                submitButton.prop('disabled', true);
            });
        },

        sendCode: function () {
            var self = this;

            self.$message.text(self.options.locale.sending);

            self.loadingButton(self.$modal.find('button[type=submit]'), true);

            $.ajax({
                type: "POST",
                url: self.options.sendingCodeUrl,
                data: {'phone': self.options.phone, '_token': self.options['_token']},
                dataType: 'json',
                success: function (response) {

                    self.$message.text(self.options.locale.sent);

                    self.loadingButton(self.$modal.find('button[type=submit]'), false);

                },
                error: function () {

                    self.$message.text(self.options.locale.sendError);

                },
                complete: function () {

                    setTimeout(function () {

                        self.$message.text('');

                    }, 4000)

                }
            })
        },

        modal: function () {
            return `
            <div class="modal" id="gsmConfirmModal" tabindex="-1" role="dialog" aria-labelledby="gsmConfirmModalLabel"
                 aria-hidden="true">
                <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                    <form id="gsmConfirmForm" method="post" action="#" class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">${$.fn.gsmConfirmation.options.locale.title}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <label for="gsmConfirmationCode" class="text-muted">
                                <small>${$.fn.gsmConfirmation.options.locale.gsmInfo}</small>
                            </label>

                            <div class="verification-code-container">
                                <input type="text" class="verification-digit" maxlength="1" data-index="0" />
                                <input type="text" class="verification-digit" maxlength="1" data-index="1" />
                                <input type="text" class="verification-digit" maxlength="1" data-index="2" />
                                <input type="text" class="verification-digit" maxlength="1" data-index="3" />
                                <input type="text" class="verification-digit" maxlength="1" data-index="4" />
                                <input type="text" class="verification-digit" maxlength="1" data-index="5" />
                            </div>

                            <input type="hidden" name="code" id="gsmConfirmationCodeHidden" />

                             <div class="errors"></div>
                        </div>
                        <div class="modal-footer">
                            <small class="mr-auto" id="gsmConfirmMessage"></small>
                            <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">
                                ${$.fn.gsmConfirmation.options.locale.buttonClose}
                            </button>
                            <button type="submit" class="btn btn-sm btn-primary" data-loading-text="${$.fn.gsmConfirmation.options.locale.buttonConfirmLoading}" disabled>
                                ${$.fn.gsmConfirmation.options.locale.buttonConfirm}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            `
        },

        $modal: null,

        $form: null,

        $message: null,

        loadingButton: function (el_button, disable) {
            var currentLoadingText = el_button.attr('data-loading-text'),
                currentText = el_button.html();

            el_button.html(decodeURIComponent(currentLoadingText));
            el_button.attr('data-loading-text', encodeURIComponent(currentText))

            if (disable) {
                el_button.prop('disabled', true);
            } else {
                el_button.prop('disabled', false);
            }
        }
    };

    $.fn.gsmConfirmation = function (options) {
        return this.each(function () {
            var gsmConfirmation = Object.create(GsmConfirmation);

            gsmConfirmation.init(options, this);

            $.data(this, 'gsmConfirmation', gsmConfirmation);

        });
    };

    $.fn.gsmConfirmation.options = {
        phone: false,
        checkingUrl: false,
        sendingCodeUrl: false,
        confirmCodeUrl: false,
        additionalInputName: false,
        beforeSubmit: function () {
        },
        locale: {
            title: 'GSM Onay',
            gsmInfo: 'Sipariş verebilmek için GSM numaranıza gönderilen 6 haneli kodu girerek doğrulama yapmalısınız.',
            sending: 'Sms gönderiliyor...',
            sent: 'Sms kodu gönderildi.',
            sendError: 'Hata oluştu. Tekrar deniniz...',
            buttonClose: 'Kapat',
            buttonConfirm: 'Onayla',
            buttonConfirmLoading: 'Onaylanıyor...'
        },
    };

})(jQuery, window, document);
